import React from 'react';
import { useTranslation } from 'react-i18next';
import { Archive, Package, PackageOpen, Truck } from 'lucide-react';

import { LabelType } from '../../services/types';

interface LabelTypeSelectorProps {
  selectedType: LabelType;
  onTypeChange: (type: LabelType) => void;
}

interface LabelTypeOption {
  id: LabelType;
  icon: React.FC<{ className?: string }>;
  label: string;
  disabled?: boolean;
}

export const LabelTypeSelector: React.FC<LabelTypeSelectorProps> = ({
  selectedType,
  onTypeChange,
}) => {
  const { t } = useTranslation();

  const labelTypes: LabelTypeOption[] = [
    {
      id: LabelType.INTERNAL_PART,
      icon: Package,
      label: t('labelPrinting.types.internalPart', {
        defaultValue: 'Internal Part',
      }),
    },
    {
      id: LabelType.EXTERNAL_PART,
      icon: PackageOpen,
      label: t('labelPrinting.types.externalPart', {
        defaultValue: 'External Part',
      }),
    },
    {
      id: LabelType.SHIPPING,
      icon: Truck,
      label: t('labelPrinting.types.shipping', {
        defaultValue: 'Shipping',
      }),
    },
    {
      id: LabelType.BIN,
      icon: Archive,
      label: t('labelPrinting.types.bin', {
        defaultValue: 'Bin',
      }),
    },
  ];

  return (
    <div className="space-y-3">
      {labelTypes.map((type) => {
        const IconComponent = type.icon;
        return (
          <button
            key={type.id}
            onClick={() => !type.disabled && onTypeChange(type.id)}
            disabled={type.disabled}
            className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg border-2 transition-all ${
              type.disabled
                ? 'border-gray-100 bg-gray-50 text-gray-400 cursor-not-allowed opacity-50'
                : selectedType === type.id
                  ? 'border-blue-500 bg-blue-50 text-blue-900'
                  : 'border-gray-200 bg-white text-gray-700 hover:border-gray-300'
            }`}
          >
            <IconComponent className="w-5 h-5 flex-shrink-0" />
            <span className="font-medium text-sm">{type.label}</span>
          </button>
        );
      })}
    </div>
  );
};
